<template>
  <div>
    <loading
      :active="isLoading"
      :can-cancel="true"
      :on-cancel="onCancel"
      :is-full-page="isFullPage"
      color="#0088CC"
    />
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

export default {
  name: 'BaseLoading',
  components: {
    Loading,
  },
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
    isFullPage: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onCancel() {
      this.$emit('cancelLoading', true)
    },
  },
}
</script>

<style lang="scss">
.vld-overlay {
  .vld-icon {
    svg {
      width: 40px;
      height: 40px;
    }
  }
}
</style>
